import animation from '../../utils/animation';

export default class Assistance {
  constructor() {
    this.$form = $('#assistance-form');
    this.$inputfile = $('#assistance-form-attachments');
    this.$inputfileAttachments = $('#assistance-form-attachments-value');
    this.$filesSelected = $('#assistance-form-files-selected');
    this.$submit = $('#assistance-submit');
  }

  init() {
    this.inputFile();
    this.handleSubmit();
  }

  inputFile() {
    this.$inputfile.on('change', async (e) => {
      const $this = $(e.currentTarget);
      const filesLength = $this[0].files.length;

      if ($this[0].files && $this[0].files[0]) {
        const maxAllowedSize = 0.5 * 1024 * 1024; // max 500KB
        if ($this[0].files[0].size > maxAllowedSize) {
          this.$filesSelected.text(this.$filesSelected.attr('data-exceed-weight'));
        } else {
          const response = await this.tobase64Handler([...$this[0].files]);
          this.$filesSelected.text(`${filesLength} ${filesLength === 1 ? 'file' : 'files'}`);
          this.$inputfileAttachments.val(JSON.stringify(response));
        }
      }
    });
  }

  async tobase64Handler(files) {
    const filePathsPromises = [];

    files.forEach((file) => {
      filePathsPromises.push(this.toBase64(file));
    });

    const filePaths = await Promise.all(filePathsPromises);
    return filePaths.map((base64File) => base64File);
  }

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({
          Name: file.name,
          ContentType: file.type,
          Body: reader.result.replace(/^data:.+;base64,/, '')
        });
      reader.onerror = (error) => reject(error);
    });
  }

  handleSubmit() {
    this.$form.on('submit', (e) => {
      const $form = $(e.currentTarget);
      e.preventDefault();
      this.$submit.attr('disabled', true);
      this.$submit.spinner().start();

      const clearElements = () => {
        $($form).trigger('reset');
        this.$submit.attr('disabled', false);
        this.$submit.spinner().stop();
        this.$filesSelected.text('');
        this.$inputfileAttachments.val('');
      };

      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: $form.serialize(),
        success: (data) => {
          animation.webToCase(data);
          clearElements();
        },
        error: () => {
          animation.webToCase({ error: true, msg: this.$form.attr('data-unsuccess-msg') });
          clearElements();
        }
      });
    });
  }
}
